import { render, staticRenderFns } from "./SelectSharerRates.vue?vue&type=template&id=0924c650&scoped=true"
import script from "./SelectSharerRates.vue?vue&type=script&lang=js"
export * from "./SelectSharerRates.vue?vue&type=script&lang=js"
import style0 from "./SelectSharerRates.vue?vue&type=style&index=0&id=0924c650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0924c650",
  null
  
)

export default component.exports